import React from "react";
import { TextEllipsis } from "component-library";
import { dataTestIds } from "data-testids";
import { DeleteIcon, RetryRedoIcon } from "assets";
import FileProgressBar from "./FileProgressBar";
import { Status } from "./FileUploadModels";

import "./FilePreview.scss";

export interface IFilePreviewTexts {
  uploadError: string;
  removeButton: string;
  retryButton: string;
}

export interface IFilePreviewProps {
  id: string;
  name: string;
  status: Status;
  percent: number;
  texts: IFilePreviewTexts;
  onRemove: (id: string) => void;
  onRetry: () => void;
}

class FilePreview extends React.PureComponent<IFilePreviewProps> {
  public render() {
    return (
      <div className="c-file-preview">
        <div className="c-file-preview__name">
          <TextEllipsis text={this.props.name} maxLine={2} />
        </div>
        {this.renderControls()}
      </div>
    );
  }

  private renderControls = () => {
    const {
      status,
      percent,
      texts: { removeButton, retryButton },
    } = this.props;

    return (
      <div className="c-file-preview__controls">
        {status === Status.Progress && (
          <div className="c-file-preview__progress">
            <FileProgressBar percent={percent} />
          </div>
        )}
        {status === Status.Success && (
          <button
            type="button"
            className="c-file-preview__button"
            data-testid={dataTestIds.profile["Media.FilePreview.DeleteButton"]}
            title={removeButton}
            onClick={() => this.handleRemove()}
          >
            <DeleteIcon />
          </button>
        )}
        {status === Status.Failed && (
          <>
            <button
              type="button"
              className="c-file-preview__button"
              title={retryButton}
              onClick={this.retryUpload}
            >
              <RetryRedoIcon />
            </button>
            <button
              type="button"
              className="c-file-preview__button"
              title={removeButton}
              onClick={() => this.handleRemove()}
            >
              <DeleteIcon />
            </button>
          </>
        )}
      </div>
    );
  };

  private handleRemove = () => {
    this.props.onRemove(this.props.id);
  };

  private retryUpload = () => {
    this.props.onRetry();
  };
}

export default FilePreview;
